import { Isvg } from './svg.interface';

const CheckboxIndeterminate = ({ width = 24, height = 24, color = '#006aff' }: Isvg) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.625 3H6.375C4.51104 3 3 4.51104 3 6.375V17.625C3 19.489 4.51104 21 6.375 21H17.625C19.489 21 21 19.489 21 17.625V6.375C21 4.51104 19.489 3 17.625 3Z"
      fill={color}
    />
    <path d="M8.41448 12.2617L15.5908 12.2617" stroke="white" strokeWidth="1.5" />
  </svg>
);

export default CheckboxIndeterminate;
